import { taskNotification } from '@/network/websocket.js'
import { Message } from 'element-ui';
import { Notification } from 'element-ui';

const websocketInfo = {
    state: {
        websocket: null,
        taskCount: 0
    },
    mutations: { //这
        async getSysconfByName(state, userInfo) {
            this.commit('initWebSocket', userInfo);
        },
        initWebSocket(state, userInfo) {
            //初始化weosocket
            let userId = userInfo.userId;
            const wsuri = `ws://pm.globalstech.com:49996/websocket?sid=${userId}`
            state.websocket = new WebSocket(wsuri)
            state.websocket.onopen = this.commit('websocketonopen');
            state.websocket.onerror = () => { this.commit('websocketonerror') }
            state.websocket.onmessage = (e) => { this.commit('websocketonmessage', e); };
            state.websocket.onclose = () => { this.commit('websocketclose') }
            setTimeout(() => {
                this.dispatch('obtainTaskNotification', userId);
            }, 1000);
        },
        destroyed: function() {
            //关闭长连接
            this.websocketclose()
        },
        websocketonopen(e) {
            console.log('WebSocket连接成功');
        },
        websocketonerror(e) {
            //错误
            console.log('WebSocket连接发生错误')
        },
        websocketonmessage(...args) {
            Notification.info({ message: `新增一条未读消息，请及时查看！` });
        },

        websocketsend(state, agentData) {
            //数据发送
            state.websocket.send(agentData)
        },

        websocketclose(state, e) {
            //关闭
            state.websocket.close();
        }
    },
    actions: {
        async obtainTaskNotification({ commit, state }, userId) {
            let { data: taskData } = await taskNotification({ userid: userId });
            if (taskData && taskData.taskCount > 0) {
                if (Number(sessionStorage.getItem('isShowTask')) !== 1) {
                    sessionStorage.setItem('isShowTask', 1);
                    Notification.info({ message: `您有${taskData.taskCount}条未读消息！` });
                }
            }
            state.taskCount = taskData.taskCount;
        }
    }
}

export default websocketInfo;


// WEBPACK FOOTER //
// ./src/store/websocketInfo.js